import dayjs, { Dayjs } from "dayjs"

export const formatDateReadable = (inputDate: string): string => {
  const date = new Date(inputDate)

  // Format the month using short form (e.g., "Jun")
  const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    date
  )

  const day = date.getDate()

  // Format the day with appropriate suffix
  const daySuffix =
    day === 1 || day === 21 || day === 31
      ? "st"
      : day === 2 || day === 22
      ? "nd"
      : day === 3 || day === 23
      ? "rd"
      : "th"

  const formattedDate = `${month} ${day}${daySuffix}, ${date.getFullYear()}`

  return formattedDate
}

export const formatTimeReadble = (inputDate: string): string => {
  const date = new Date(inputDate)

  // Format the month using short form (e.g., "Jun")
  const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
    date
  )

  const day = date.getDate()

  // Format the day with appropriate suffix
  const daySuffix =
    day === 1 || day === 21 || day === 31
      ? "st"
      : day === 2 || day === 22
      ? "nd"
      : day === 3 || day === 23
      ? "rd"
      : "th"

  // Format the time as hours:minutes
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`

  return `${formattedTime}`
}

export const filterOptions = [
  { label: "Today", value: "today" },
  { label: "This Week", value: "this-week" },
  { label: "Next Week", value: "next-week" },
  { label: "This Month", value: "this-month" },
]

export function getDateRange(filter: string): {
  startDate: string
  endDate: string
} {
  const fmt = (d: Dayjs) => d.format("YYYY-MM-DD")
  switch (filter) {
    case "today":
      return { startDate: fmt(dayjs()), endDate: fmt(dayjs()) }
    case "this-week":
      return {
        startDate: fmt(dayjs().startOf("week")),
        endDate: fmt(dayjs().endOf("week")),
      }
    case "next-week":
      return {
        startDate: fmt(dayjs().add(1, "week").startOf("week")),
        endDate: fmt(dayjs().add(1, "week").endOf("week")),
      }
    case "this-month":
    default:
      return {
        startDate: fmt(dayjs().startOf("month")),
        endDate: fmt(dayjs().endOf("month")),
      }
  }
}
